import i18n from 'i18next'
import { merge } from 'lodash'
import resourcesCrude from '@3m5/crude-frontend/dist/shared/translations/locales'

import { isDebugEnv } from '~config/envConfig'
import resourcesLocal from './locales'
import { initReactI18next } from 'react-i18next'

interface Language {
  code: string
  codeShort: string
  name: string
}

// const resourcesOld = merge(resourcesLocal, resourcesCrude)
const resources = merge(resourcesLocal, {
  'de-DE': resourcesCrude.de,
  'en-US': resourcesCrude.en,
  'es-ES': resourcesCrude.es,
  'fr-FR': resourcesCrude.fr,
  'it-IT': resourcesCrude.it,
  'pl-PL': resourcesCrude.pl,
  'pt-PT': resourcesCrude.pt,
  'ru-RU': resourcesCrude.ru,
  'tr-TR': resourcesCrude.tr
})

export const i18nResourcesDe = resources['de-DE']
export type i18nResourcesType = typeof i18nResourcesDe

export const availableLanguages: Language[] = Object.keys(resources).map((key) => {
  const typedKey = key as keyof typeof resources
  return {
    code: resources[typedKey].language?.code || 'Language code is missing!',
    codeShort: resources[typedKey].language?.codeShort || 'Language code is missing!',
    name: resources[typedKey].language?.name || 'Language name is missing!',
  }
})

i18n.on('initialized', function(initialized) {
  if (isDebugEnv) {
    console.groupCollapsed('i18n initialized')
    console.log('initialized', initialized)
    console.log('resources', resources)
    console.groupEnd()
  }
})

const i18nInstance = i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: Object.keys(resources).includes(window.navigator.language)
      ? window.navigator.language
      : 'de-DE',
    fallbackLng: 'en-US',
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
    },
    // ns: [],
    defaultNS: 'common',
    react: { wait: true, useSuspense: false },
  })

export default i18nInstance
